import { createContext } from 'react';

const defaultValues = {
	cakeUrl: 'https://my.smartthings.com',
};

export const ConfigContext = createContext<Record<string, any>>(defaultValues);
